import {Component, OnInit, Input, Inject} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ContributionDTO} from '../../../../ent/models/ContributionDTO';
import {BasicPersonDetailDTO} from '../../../../ent/models/person/BasicPersonDetailDTO';
import {MemberContributionService} from '../../../../ent/services/member-contribution.service';
import {Moment} from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import * as moment from 'moment';
import {DateUtil} from '../../../util/DateUtil';
import { SharedService } from '../../../services/shared-service';

enum TableColumns {
  Date = 'date',
  OpeningBalance = 'openingBalance',
  MemberRaised = 'memberRaised',
  MemberPaid = 'memberPaid',
  CompanyRaised = 'companyRaised',
  CompanyPaid = 'companyPaid',
  ClosingBalance = 'closingBalance',
  Total = 'total'
}

export const DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM',
  },
  display: {
    dateInput: 'YYYY-MM',
    monthYearLabel: 'YYYY MMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY MMMM',
  },
};

@Component({
  selector: 'member-contributions-overview',
  templateUrl: './contributions-overview.component.html',
  styleUrls: ['./contributions-overview.component.scss'],
  providers: [{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
  }, {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS}]
})
export class ContributionsOverviewComponent implements OnInit {
  readonly DateUtil = DateUtil;
  date = new FormControl(moment());
  maxDate: Date = new Date();

  @Input() policyNumber: string;

  tableColumns = TableColumns;
  tableDisplayedColumns: string[] = Object.values(TableColumns);
  memberContributionsDataSource: MatTableDataSource<ContributionDTO> = new MatTableDataSource();


  constructor(
    private memberContributionService: MemberContributionService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public basicPersonDetails: BasicPersonDetailDTO) {
  }

  ngOnInit(): void {
    this.retrieveContributions();
  }

  private retrieveContributions() : void {
    if (!this.policyNumber) {
      return;
    }

    const externalMembershipNumber = this.policyNumber;
    this.memberContributionService.getMemberContribution(this.basicPersonDetails.optionCode, externalMembershipNumber, String(this.date.value.year()), String(this.date.value.month() + 1)).subscribe({
      next: (response: ContributionDTO[]) => {
        this.memberContributionsDataSource.data = response;
      },
      error: (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    });
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.date.setValue(normalizedMonthAndYear);
    datepicker.close();
    this.memberContributionsDataSource.data = [];
    this.retrieveContributions();
  }

  get doesDataExist(): boolean {
    return !!(this.memberContributionsDataSource && this.memberContributionsDataSource.data?.length);
  }
}
